document.addEventListener("DOMContentLoaded", function () {
  const defaultCurrency = "EUR";
  const currencyDropdown = document.getElementById("currency-select");
  let selectedCurrency = localStorage.getItem("selectedCurrency") || defaultCurrency;
  let exchangeRates = {};

  const currencySymbols = {
    AED: "د.إ", AFN: "؋", ALL: "L", AMD: "֏", ANG: "ƒ", AOA: "Kz", ARS: "$", AUD: "A$", AWG: "ƒ",
    AZN: "₼", BAM: "KM", BBD: "$", BDT: "৳", BGN: "лв", BHD: ".د.ب", BIF: "FBu", BMD: "$", BND: "$",
    BOB: "Bs", BRL: "R$", BSD: "$", BTN: "Nu.", BWP: "P", BYN: "Br", BZD: "$", CAD: "C$", CDF: "FC",
    CHF: "CHF", CLP: "$", CNY: "¥", COP: "$", CRC: "₡", CUP: "$", CVE: "$", CZK: "Kč", DJF: "Fdj",
    DKK: "kr", DOP: "$", DZD: "دج", EGP: "£", ERN: "Nfk", ETB: "Br", EUR: "€", FJD: "$", FKP: "£",
    FOK: "kr", GBP: "£", GEL: "₾", GGP: "£", GHS: "₵", GIP: "£", GMD: "D", GNF: "FG", GTQ: "Q",
    GYD: "$", HKD: "$", HNL: "L", HRK: "kn", HTG: "G", HUF: "Ft", IDR: "Rp", ILS: "₪", IMP: "£",
    INR: "₹", IQD: "ع.د", IRR: "﷼", ISK: "kr", JEP: "£", JMD: "$", JOD: "د.ا", JPY: "¥", KES: "Sh",
    KGS: "с", KHR: "៛", KID: "$", KMF: "CF", KRW: "₩", KWD: "د.ك", KYD: "$", KZT: "₸", LAK: "₭",
    LBP: "ل.ل", LKR: "Rs", LRD: "$", LSL: "L", LYD: "ل.د", MAD: "د.م.", MDL: "L", MGA: "Ar", MKD: "ден",
    MMK: "K", MNT: "₮", MOP: "P", MRU: "UM", MUR: "₨", MVR: "Rf", MWK: "MK", MXN: "$", MYR: "RM",
    MZN: "MT", NAD: "$", NGN: "₦", NIO: "C$", NOK: "kr", NPR: "₨", NZD: "$", OMR: "ر.ع.", PAB: "B/.",
    PEN: "S/", PGK: "K", PHP: "₱", PKR: "₨", PLN: "zł", PYG: "₲", QAR: "ر.ق", RON: "lei", RSD: "дин.",
    RUB: "₽", RWF: "FRw", SAR: "ر.س", SBD: "$", SCR: "₨", SDG: "ج.س.", SEK: "kr", SGD: "$", SHP: "£",
    SLL: "Le", SOS: "Sh", SRD: "$", SSP: "£", STN: "Db", SYP: "£", SZL: "L", THB: "฿", TJS: "ЅМ",
    TMT: "T", TND: "د.ت", TOP: "T$", TRY: "₺", TTD: "$", TVD: "$", TWD: "NT$", TZS: "Sh", UAH: "₴",
    UGX: "Sh", USD: "$", UYU: "$", UZS: "so'm", VES: "Bs.", VND: "₫", VUV: "Vt", WST: "T", XAF: "FCFA",
    XCD: "$", XOF: "CFA", XPF: "₣", YER: "﷼", ZAR: "R", ZMW: "ZK", ZWL: "$"
  };

  function fetchRates() {
    fetch("https://www.floatrates.com/daily/eur.json")
      .then(res => res.json())
      .then(data => {
        exchangeRates = {};
        for (const code in data) {
          exchangeRates[code.toUpperCase()] = data[code].rate;
        }
        exchangeRates[defaultCurrency] = 1;
        convertPrices();
      })
      .catch(err => console.error("Exchange rate error:", err));
  }

  function convertPrices() {
    const currency = selectedCurrency.toUpperCase();
    const symbol = currencySymbols[currency] || currency;

    document.querySelectorAll("[data-price]").forEach(el => {
      const base = parseFloat(el.getAttribute("data-price"));
      if (!isNaN(base) && exchangeRates[currency]) {
        const newPrice = (base * exchangeRates[currency]).toFixed(2);
        el.innerText = `${newPrice} ${symbol}`;
      }
    });
  }

  function initCurrencyDropdown(geoCurrency) {
    const supported = [defaultCurrency, "USD", geoCurrency.toUpperCase()];
    const unique = [...new Set(supported)];

    currencyDropdown.innerHTML = "";
    unique.forEach(code => {
      const option = document.createElement("option");
      option.value = code;
      option.textContent = code;
      currencyDropdown.appendChild(option);
    });

    // Use localStorage or fallback to default
    const saved = localStorage.getItem("selectedCurrency");
    selectedCurrency = saved && unique.includes(saved) ? saved : defaultCurrency;
    currencyDropdown.value = selectedCurrency;

    currencyDropdown.addEventListener("change", function () {
      selectedCurrency = this.value;
      localStorage.setItem("selectedCurrency", selectedCurrency);
      convertPrices();
    });
  }

  // Step 1: Detect geolocation currency
  fetch("https://ipapi.co/json")
    .then(res => res.json())
    .then(data => {
      const geoCurrency = data.currency || defaultCurrency;
      initCurrencyDropdown(geoCurrency);
      fetchRates();
    })
    .catch(() => {
      initCurrencyDropdown(defaultCurrency);
      fetchRates();
    });
});







